declare const process: { env: { NODE_ENV?: string } } | undefined;

/** True outside production builds. Bundlers replace `process.env.NODE_ENV` with a constant. */
export function isDevelopment(): boolean {
  return typeof process !== "undefined" && process.env.NODE_ENV !== "production";
}
